import type { VoidFunctionComponent } from 'react';

import { nuc } from '../../../../../utils';
import { RouterLink } from '../../../../generic';
import Icon from '../../../../generic/Icon';
import Tooltip from '../../../../generic/Tooltip';
import { projectTypes } from '../../../shared/projectTypesIconMap';
import type { Project } from '../../../../../../shared/projectsV2';

import { OriginOrganizationNameBadge } from './OriginOrganizationNameBadge';

type Props = {
  project: Project;
};

export type ProjectTypesKey = keyof typeof projectTypes;

export const ProjectIcon: VoidFunctionComponent<{ projectTypeKey: ProjectTypesKey }> = ({ projectTypeKey }) => {
  const projectType = projectTypes[projectTypeKey];

  if (!projectType) {
    return null;
  }

  const title = projectType.title;
  const icon = projectType.icon;

  return (
    <Tooltip tooltip={title} id="project-icon-tooltip">
      <span className="project-item__title_icon">
        <Icon icon={icon} />
      </span>
    </Tooltip>
  );
};

const ProjectTitle: VoidFunctionComponent<Props> = ({ project }: Props) => {
  return (
    <div className="project-item__title">
      <RouterLink
        to={`/projects/${nuc(project.id)}`}
        className="projects-table__row__link"
      >
        <Tooltip showTooltip tooltip={project.title} id="project-title-tooltip">
          <div className="project-item__title__text">{project.title}</div>
        </Tooltip>
      </RouterLink>
      {!project.public && <ProjectIcon projectTypeKey="private" />}
      {project.type && <ProjectIcon projectTypeKey={project.type as ProjectTypesKey} />}
      <OriginOrganizationNameBadge originOrganizationName={project.originOrganizationName} />
    </div>
  );
};

export default ProjectTitle;
